import { useEffect, useState } from 'react'
import Axios from "axios"
import './App.css'

function App() {

  const [nombre, setNombre] = new useState("")
  const [edad, setEdad] = new useState(0)
  const [pais, setPais] = new useState("")
  const [cargo, setCargo] = new useState("")
  const [años, setAños] = new useState(0)
  const [empleadosLista, setEmpleados] = new useState([])
  const url = "http://https://prueba-server-py4h.onrender.com"

  const getEmpleados = () => {
    Axios.get(`${url}/empleados`).then(res => {
      setEmpleados(res.data)
    })
  }

  const add = () => {
    Axios.post(`${url}/create`, {
      nombre, 
      edad,
      pais,
      cargo,
      años
    }).then(() => getEmpleados())
  }

  useEffect(() => {
    getEmpleados()
  }, [])

  return (
    <div className="App">
      <div className="datos">
        <label>Nombre: 
          <input type="text" onChange={e => setNombre(e.target.value)}/>
        </label>

        <label>Edad: 
          <input type="number" onChange={e => setEdad(e.target.value)}/>
        </label>

        <label>País: 
          <input type="text" onChange={e => setPais(e.target.value)}/>
        </label>

        <label>Cargo: 
          <input type="text" onChange={e => setCargo(e.target.value)}/>
        </label>

        <label>Años: 
          <input type="number" onChange={e => setAños(e.target.value)}/>
        </label>

        <button onClick={add}>Registrar</button>
      </div>

      <div className="lista">
        {
          empleadosLista.map((val, key) => {
            return (
              <div className="empleado">
                {val.nombre}, {val.edad} años
              </div>
            )
          })
        }
      </div>
    </div>
  );
}

export default App;
